<template>
  <div class="pc_main-info">
    <div>
      <div class="price-main">
        <el-form
          ref="ruleForm"
          label-position="top"
          label-width="80px"
          :model="form"
          :rules="rules"
          :hide-required-asterisk="true"
        >
          <h5>{{ $t('PCUserInfo.index.647kboa03ks0') }}</h5>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa06ys0')" prop="userName">
                <el-input v-model="form.userName" maxlength="64"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('PCUserInfo.index.647kboa078s0')"
                prop="mobile"
                class="input-mobileNumber-item"
              >
                <el-input
                  ref="input-mobileNumber"
                  v-model="form.mobile"
                  :placeholder="$t('components.section7.646ns2k5gx40')"
                  :maxlength="16"
                  @focus="focus"
                >
                  <el-select
                    slot="prepend"
                    v-model="form.mobileAreaCode"
                    :popper-append-to-body="false"
                    style="width: 160px"
                  >
                    <img slot="prefix" :src="getFlagUrl" alt="" style="width: 24px; height: 24px" />
                    <el-option
                      v-for="item in mobileAreaCode"
                      :key="item.areaCode"
                      :value="item.areaCode"
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          :src="item.flagUrl"
                          alt=""
                          style="width: 24px; height: 24px; margin-right: 10px"
                        />
                        {{ item.areaCode }} {{ item.countryName }}
                      </div>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="idCard">
                <template #label>
                  <div class="label-with-tooltip">
                    <span>
                      {{ $t('PCUserInfo.index.647kboa0idc0') }}
                    </span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content" style="white-space: pre-line">
                        {{ $t('PCUserInfo.index.647kboa0idc1') }}
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </template>
                <el-input v-model="form.idCard" maxlength="30" @input="handleInput"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h5>{{ $t('PCUserInfo.index.647kboa07d00') }}</h5>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa07jk0')" prop="countryCode">
                <el-select
                  v-model="form.countryCode"
                  filterable
                  :placeholder="$t('PCUserInfo.index.647kboa07p80')"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.countryCode"
                    :label="item.country"
                    :value="item.countryCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa08b40')" prop="pinCode">
                <el-select
                  v-model="form.pinCode"
                  filterable
                  :placeholder="$t('PCUserInfo.index.647kboa07p80')"
                  :remote-method="remotePinCode"
                  remote
                  style="width: 100%"
                  max
                  @change="getCities('')"
                >
                  <el-option
                    v-for="item in postCodeList"
                    :key="item.postCode"
                    :label="item.postCode"
                    :value="item.postCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa08h00')" prop="city">
                <el-select
                  v-model="form.city"
                  filterable
                  :placeholder="$t('PCUserInfo.index.647kboa07p80')"
                  :remote-method="remoteCity"
                  style="width: 100%"
                  remote
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.placeName"
                    :label="item.placeName"
                    :value="item.placeName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('PCUserInfo.index.647kboa08zc0')" class="addressInput">
                <el-input v-model="form.address" maxlength="105" show-word-limit :placeholder="$t('PCUserInfo.index.addreddPlaceholder')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h5>{{ $t('PCUserInfo.index.647kboa09440') }}</h5>
          <el-row :gutter="40">
            <el-col v-if="nationCode == 'GB'" :span="12">
              <!-- <el-form-item label="Sort Code">
                <el-input v-model="form.bic"></el-input>
              </el-form-item> -->

              <el-form-item label="Sort Code" prop="bic">
                <el-input
                  v-model="form.bic"
                  maxlength="8"
                  placeholder="e.g. 20-19-63"
                  @input="formatSortCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="iban">
                <template #label>
                  <div class="label-with-tooltip">
                    <span> {{ nationCode == 'GB' ? 'Account Number' : 'IBAN' }} </span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content" style="white-space: pre-line">
                        {{ $t('PCUserInfo.index.ibanTip') }}
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </template>
                <!-- <el-input v-model="formattedIBAN" maxlength="42" @input="formatIBAN"></el-input> -->
                <el-input
                  v-if="nationCode == 'GB'"
                  v-model="form.iban"
                  maxlength="8"
                  placeholder="e.g. 12345678"
                  @input="validateAccountNumber"
                ></el-input>
                <el-input
                  v-else
                  v-model="formattedIBAN"
                  maxlength="42"
                  @input="formatIBAN"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="24">
              <div class="declaration">
                <span>
                  {{ $t('PCUserInfo.index.declaration') }}
                </span>
                <span class="download" @click="download">
                  <i class="el-icon-download"></i> {{ $t('PCUserInfo.index.download') }}
                </span>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { lang } from '@/locales';
import { getMobileAreaCode } from '@/services/api/home';
import {
  getCities,
  getCode,
  getCountries,
  getPostCode,
  verifyCode
} from '@/services/api/settleAccount';
export default {
  name: 'PCUserInfo',
  components: {},
  props: {
    dataList: Array,
    moneyData: Object,
    info: Object,
    nationCode: String
  },
  data() {
    // 验证前两位必须为字母的规则
    const validateIBAN = (rule, value, callback) => {
      const rawValue = value.replace(/\s+/g, '');
      if (!/^[A-Z]{2}/.test(rawValue)) {
        callback(new Error(this.$t('PCUserInfo.index.idError')));
      } else {
        callback();
      }
    };

    const validateIDCard = (rule, value, callback) => {
      const rawValue = value.replace(/\s+/g, '');
      if (!/^[A-Za-z0-9\-/]{6,30}$/.test(rawValue)) {
        callback(new Error(this.$t('PCUserInfo.index.idError')));
      } else {
        callback();
      }
    };

    return {
      lang,
      form: {
        userName: '',
        mobile: '',
        countryCode: '',
        pinCode: '',
        city: '',
        address: '',
        bic: '',
        iban: '',
        email: '',
        idCard: '',
        mobileAreaCode: ''
      },
      mobileAreaCodeList: {
        ES: '+34',
        IT: '+39',
        GB: '+44',
        FR: '+33',

        // 德语系国家
        AT: '+43', // 奥地利
        DE: '+49', // 德国
        LU: '+352', // 卢森堡
        PT: '+351', // 葡萄牙
        PL: '+48' // 波兰
      },
      rules: {
        userName: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        ],
        countryCode: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        pinCode: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        city: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        address: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'blur' }
        ],

        idCard: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' },
          { validator: validateIDCard, trigger: 'blur' }
        ],
        // iban: [
        //   { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        // ],
        // bic: [
        //   { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        // ],
        // iban: [
        //   { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' },
        //   { validator: validateIBAN, trigger: 'blur' },
        //   {
        //     pattern: /^[A-Z0-9\s]{6,34}$/,
        //     message: this.$t('PCUserInfo.index.idError'),
        //     trigger: 'blur'
        //   }
        // ],

        bic: [
          {
            required: true,
            message: this.$t('PCUserInfo.index.647kboa09u40'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (this.nationCode === 'GB') {
                if (!/^\d{2}-\d{2}-\d{2}$/.test(value)) {
                  callback(new Error('Please enter a valid Sort Code (e.g. 20-19-63)'));
                } else {
                  callback();
                }
              } else {
                // Non-GB BIC validation if needed
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        iban: [
          {
            required: true,
            message: this.$t('PCUserInfo.index.647kboa09u40'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (this.nationCode === 'GB') {
                // GB account number validation (8 digits)
                if (!/^\d{8}$/.test(value)) {
                  callback(new Error('Please enter a valid 8-digit account number'));
                } else {
                  callback();
                }
              } else {
                // IBAN validation for non-GB countries
                validateIBAN(rule, value, callback);
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        ],
        code: [
          // { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
          { required: true, validator: this.blur, trigger: 'blur' }
        ] //验证码校验
      },
      countryList: [
        {
          country: 'United Kingdom',
          countryCode: 'GB',
          placeName: '',
          postCode: ''
        },
        {
          country: 'France',
          countryCode: 'FR',
          placeName: '',
          postCode: ''
        },
        {
          country: 'Spain',
          countryCode: 'ES',
          placeName: '',
          postCode: ''
        },
        {
          country: 'Germany',
          countryCode: 'DE',
          placeName: '',
          postCode: ''
        },
        {
          country: 'Portugal',
          countryCode: 'PT',
          placeName: '',
          postCode: ''
        },
        {
          country: 'Poland',
          countryCode: 'PL',
          placeName: '',
          postCode: ''
        }
      ],
      postCodeList: [],
      cityList: [],
      timer: null,
      text: this.$t('PCUserInfo.index.647kboa09z80'),
      isPass: false,
      showTip: false,
      showEmailErrorTip: false,
      alreadySend: false, // 是否发过验证码
      code: '',
      mobileAreaCode: [],
      isDownload: false
    };
  },
  computed: {
    getFlagUrl() {
      // form.mobileAreaCode
      let url = '';
      this.mobileAreaCode.forEach(item => {
        if (item.areaCode == this.form.mobileAreaCode) {
          url = item.flagUrl;
        }
      });
      return url;
    },
    downLoadHref() {
      return `https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/${this.lang}_oppoeu_declaration.pdf`;
    },
    // 格式化后的 IBAN（带空格）
    formattedIBAN: {
      get() {
        return this.addSpaces(this.form.iban);
      },
      set(value) {
        // 去除空格并存储原始值
        this.form.iban = value.replace(/\s+/g, '');
      }
    }
  },
  watch: {
    info: {
      deep: true,
      handler(val) {
        if (!val) {
          return;
        }
        Object.keys(this.form).forEach(key => {
          if (typeof val[key] !== 'undefined' && val[key] !== null && val[key] !== '') {
            this.form[key] = val[key];
          }
        });
        if (typeof val.isDownload !== 'undefined') {
          this.isDownload = val.isDownload;
        }
      }
    },
    form: {
      async handler(newData, oldData) {
        let isValidateIdCard = false;
        let isValidateIban = false;

        if (this.form.idCard) {
          isValidateIdCard = await this.validateIdCardFields();
        }

        if (this.form.idCard) {
          isValidateIban = await this.validateIbanFields();
        }

        console.log({
          idCard: !isValidateIdCard ? this.form.idCard : '',
          iban: !isValidateIban ? this.form.iban : '',
          isDownload: this.isDownload
        });

        this.$emit(
          'completeData',
          {
            ...this.form,
            idCard: !isValidateIdCard ? this.form.idCard : '',
            iban: !isValidateIban ? this.form.iban : ''
          },
          this.isDownload
        );
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.getEnumList();
    // this.getCountries();
    this.$nextTick(() => {
      this.countryList = this.countryList.filter(item => item.countryCode === this.nationCode);
    });

    this.form = { ...this.form, ...this.info };
    const defaultAreaCode = this.mobileAreaCodeList[this.$route.query.nationCode];
    // 优先接口回填；否则按 nationCode 默认区号（避免父级空值/旧默认 +34 盖住 PT/PL）
    this.form.mobileAreaCode = this.info.mobileAreaCode || defaultAreaCode || '+34';
    if (!this.form.countryCode && this.nationCode) {
      this.form.countryCode = this.nationCode;
    }
    this.isDownload = this.info.isDownload || false;
  },
  methods: {
    // 单独校验 idCard
    validateIdCardFields() {
      return new Promise(resolve => {
        this.$refs.ruleForm.validateField(['idCard'], valid => {
          resolve(valid);
        });
      });
    },
    // 单独校验 iban
    validateIbanFields() {
      return new Promise(resolve => {
        this.$refs.ruleForm.validateField(['iban'], valid => {
          resolve(valid);
        });
      });
    },

    formatSortCode(value) {
      // Remove all non-digit characters
      let digits = value.replace(/\D/g, '');

      // Limit to 6 digits
      if (digits.length > 6) {
        digits = digits.substring(0, 6);
      }

      // Add hyphens after every 2 digits
      let formatted = '';
      for (let i = 0; i < digits.length; i++) {
        if (i > 0 && i % 2 === 0 && i < 6) {
          formatted += '-';
        }
        formatted += digits[i];
      }

      this.form.bic = formatted;
    },

    validateAccountNumber(value) {
      // For GB account numbers, allow only digits and limit to 8 characters
      this.form.iban = value.replace(/\D/g, '').substring(0, 8);
    },
    // 格式化输入（过滤非字母数字 + 转大写 + 自动加空格）
    formatIBAN(num) {
      // 1. 过滤非字母数字字符
      let value = num.replace(/[^a-zA-Z0-9]/g, '');
      // 2. 转大写
      value = value.toUpperCase();

      // 3. 更新原始值（无空格）
      this.form.iban = value;
      // 4. 重新渲染格式化后的值（带空格）
      num = this.addSpaces(value);
    },

    // 每 4 位加空格
    addSpaces(value) {
      return value.replace(/(.{4})/g, '$1 ').trim();
    },

    handleInput(num) {
      console.log(num);
      const filteredValue = num.replace(/[^a-zA-Z0-9-/]/g, '').toUpperCase();

      // 更新 form.idCard
      this.form.idCard = filteredValue;
    },
    async download() {
      fetch(this.downLoadHref)
        .then(response => response.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'declaration.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // 清理
        });

      this.isDownload = true;

      let isValidateIdCard = false;
      let isValidateIban = false;

      if (this.form.idCard) {
        isValidateIdCard = await this.validateIdCardFields();
      }

      if (this.form.idCard) {
        isValidateIban = await this.validateIbanFields();
      }

      this.$emit(
        'completeData',
        {
          ...this.form,
          idCard: !isValidateIdCard ? this.form.idCard : '',
          iban: !isValidateIban ? this.form.iban : ''
        },
        this.isDownload
      );
    },
    getEnumList() {
      getMobileAreaCode().then(res => {
        this.mobileAreaCode = [];
        const { code, data, message } = res;
        if (code === '0000') {
          this.mobileAreaCode = data;
        } else {
          this.$message({
            message: message,
            type: 'error'
          });
        }
      });
    },
    remotePinCode(value, option) {
      if (value.length >= 2) {
        this.getPostCode(value);
      }
    },
    remoteCity(value, option) {
      this.getCities(value);
    },
    // 获取国家
    // getCountries() {
    //   getCountries()
    //     .then(res => {
    //       let { code, data } = res;
    //       if (code === '0000') {
    //         this.countryList = data;
    //         this.form.countryCode = this.nationCode;
    //         this.getPostCode();
    //         // this.postCodeList = [];
    //       }
    //     })
    //     .catch(err => {});
    // },
    // 获取邮编
    getPostCode(val = '') {
      this.$set(this.form, 'pinCode', '');
      this.$set(this.form, 'city', '');
      getPostCode({
        countryCode: this.form.countryCode,
        postCode: val,
        placeName: '',
        pageNum: 1,
        pageSize: 100
      })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            this.postCodeList = data.list;
            this.cityList = [];
          }
        })
        .catch(err => {});
    },
    // 获取地区
    getCities(val = '') {
      this.$set(this.form, 'city', '');
      getCities({
        countryCode: this.form.countryCode,
        postCode: this.form.pinCode,
        placeName: val
      })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            if (data.length > 0) {
              this.cityList = data;
            }
          }
        })
        .catch(err => {});
    },
    resetForm() {
      this.$refs.formName.resetFields();
    },
    focus() {
      // let appendEl = document.getElementsByClassName('el-input-group__append')[0];
      // appendEl.style.borderColor = '#ff9600';
    }
  }
};
</script>

<style scoped lang="less">
.pc_main-info {
  width: 880px;
  border-radius: 8px;
  height: 844px;
  padding: 24px;
  background-color: #fff;
  font-size: 16px;
  color: #282828;
  padding: 40px;
  margin-bottom: 130px;
  .declaration {
    height: 48px;
    background-color: #ebebeb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 0 10px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    .download {
      color: #ff9600;
    }
  }

  /deep/.addressInput{
    .el-input__inner{
      padding-right: 80px;
    }
  }

  /deep/.el-input__inner {
    height: 48px;
    font-size: 16px;
    // background-color: #fff!important;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    &:focus {
      border: 1px solid #ff9600 !important;
    }
  }
  /deep/.el-form-item__label {
    font-size: 16px;
  }
  .medium-div {
    font-weight: 600;
  }
  .price-main {
    height: 55px;
    h5 {
      color: var(--text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 133.333% */
      margin: 0 0 20px 0;
    }
    /deep/ .el-form-item__label {
      line-height: 22px;
    }
    /deep/ .el-form-item {
      margin-bottom: 20px;
    }
    /deep/.el-row {
      margin-bottom: 20px;
    }
  }

  /deep/.el-input-group__append,
  /deep/.el-input-group__prepend {
    // background-color: no#fffne;
    background-color: #fff;
    font-size: 16px;
    color: #ff9600;
  }
  /deep/.input-mobileNumber-item {
    .el-input__prefix {
      display: flex;
      align-items: center;
    }
    .el-input-group__prepend {
      .el-input__inner {
        text-align: center;
      }
    }
  }
  /deep/.yzmInput {
    .el-input__inner {
      border-right: none;
    }
    ///deep/.el-input__inner:focus {
    //  border-color: #ff9600;
    //  // border-color: #C0C4CC;
    //  // outline: 0;
    //}
    .el-input__inner:hover + .el-input-group__append,
    .el-input-group__prepend {
      border-color: #ff9600 !important;
      background-color: none;
    }
  }

  // /deep/.el-input.is-active .el-input__inner,
  /deep/.el-input__inner:focus {
    border-color: #ff9600;
    outline: 0;
  }

  .isPass {
    width: 20px;
    height: 20px;
  }

  /deep/.el-select .el-input.is-focus .el-input__inner {
    border-color: #ff9600;
  }

  /deep/.el-input__inner:hover {
    border-color: #ff9600;
  }

  .btn {
    color: #ff9600;
    border-radius: 10px;
    cursor: pointer;
    display: block;
    padding: 10px 0;
  }
  .gray-btn {
    opacity: 0.6;
  }
}
</style>
